import { point2DDistanceTo } from '../Point2D';
import { distanceEquals } from '../units';
import { Line2Struct, Segment2Struct, Vec2Struct } from './types';
import { normalizeDirectionVec } from './vec';

/**
 * A no-allocation version of `LineSegment2D#containsPointKnownToBeOnLine`.
 *
 * Only intended for use in performance-critical code where you need to avoid heap allocations.
 */
export function segmentContainsPointKnownToBeOnLine(segment: Segment2Struct, point: Vec2Struct) {
  return distanceEquals(
    point2DDistanceTo(point, segment.basePoint) + point2DDistanceTo(point, segment.endPoint),
    point2DDistanceTo(segment.basePoint, segment.endPoint),
  );
}

/**
 * A no-allocation version of `LineSegment2D#midpoint`.
 *
 * Only intended for use in performance-critical code where you need to avoid heap allocations.
 */
export function segmentMidpoint(segment: Segment2Struct, result: Vec2Struct) {
  result.x = (segment.basePoint.x + segment.endPoint.x) / 2;
  result.y = (segment.basePoint.y + segment.endPoint.y) / 2;
}

/**
 * Creates a `Line2Struct` from a `Segment2Struct`.
 *
 * Only intended for use in performance-critical code where you need to avoid heap allocations.
 */
export function segmentToLine(segment: Segment2Struct, result: Line2Struct) {
  result.basePoint.x = segment.basePoint.x;
  result.basePoint.y = segment.basePoint.y;
  result.direction.x = segment.endPoint.x - segment.basePoint.x;
  result.direction.y = segment.endPoint.y - segment.basePoint.y;
  normalizeDirectionVec(result.direction);
}
